import { FormInstance } from "antd";
import CountryAdressDetails from "apps/Common/Adress/CountryAddressDetails";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter } from "../ClientStates";
import { useLocation } from "react-router-dom";

interface AddressProps {
  form: FormInstance;
  isMobile?: boolean;
}

const Address: FC<AddressProps> = (props) => {
  const { filter } = useSelector((state: RootState) => state.realState);
  const [selectedRecord, setSelectedRecord] = useState<any>({});
  const [addresNamesInfo, setAddresInfoe] = useState<any>({});
  const dispatch = useDispatch();
  const location = useLocation();

  const locationState = location.state as {
    locationInfo?: {
      type: "city" | "district" | "neighbourhood";
      id: number;
      name: string;
    };
    cityId?: number;
    cityName?: string;
    districtId?: number;
    districtName?: string;
    neighbourhoodId?: number;
    neighbourhoodName?: string;
  };

  // Eğer locationState varsa formu ve state'leri onunla başlat
  useEffect(() => {
    if (!locationState) return;

    const {
      cityId,
      cityName,
      districtId,
      districtName,
      neighbourhoodId,
      neighbourhoodName,
    } = locationState;

    const formValues: any = {};
    if (cityId) formValues["cityId"] = cityId;
    if (districtId) formValues["districtIds"] = [districtId];
    if (neighbourhoodId) formValues["neighbourhoodIds"] = [neighbourhoodId];
    props.form.setFieldsValue(formValues);

    const info: any = {};
    if (cityId && cityName) {
      info["CityId"] = cityId;
      info["cityName"] = cityName;
    }
    if (districtId && districtName) {
      info["DistrictIds"] = [districtId];
      info["districtNames"] = [districtName];
    }
    if (neighbourhoodId && neighbourhoodName) {
      info["NeighbourhoodIds"] = [neighbourhoodId];
      info["neighbourhoodNames"] = [neighbourhoodName];
    }

    setAddresInfoe(info);

    setSelectedRecord({
      StateProvinceId: cityId,
      DistrictIds: districtId ? [districtId] : [],
    });
  }, [locationState]);

  // Eğer locationState yoksa filtreye göre ilk değerleri set et
  useEffect(() => {
    if (locationState) return;

    const data: any = {};

    if (filter?.CityId) data["cityId"] = filter.CityId;
    if (filter?.DistrictIds) data["districtIds"] = filter.DistrictIds;
    if (filter?.NeighbourhoodIds) data["neighbourhoodIds"] = filter.NeighbourhoodIds;

    if (Object.entries(data).length > 0) {
      setSelectedRecord({
        StateProvinceId: data.cityId,
        DistrictIds: data.districtIds,
      });
    }
  }, [filter, locationState]);

  // addresNamesInfo her değiştiğinde filtreyi güncelle
  useEffect(() => {
    const cleanedData = Object.fromEntries(
      Object.entries(addresNamesInfo).filter(
        ([_, value]) =>
          !(Array.isArray(value) && value.every((item) => item == null))
      )
    );

    const currentFilter = JSON.parse(JSON.stringify({ ...filter, ...cleanedData }));

    if (!addresNamesInfo?.DistrictIds) {
      delete currentFilter["DistrictIds"];
      delete currentFilter["districtNames"];
    }
    if (!addresNamesInfo?.NeighbourhoodIds) {
      delete currentFilter["NeighbourhoodIds"];
      delete currentFilter["neighbourhoodNames"];
    }

    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  }, [addresNamesInfo]);

  return (
    <CountryAdressDetails
      pageType="advertList"
      selectInputType="block"
      selectedRecord={selectedRecord}
      addresNamesInfo={addresNamesInfo}
      setAddresNamesInfo={setAddresInfoe}
      isShowLabel={props.isMobile}
      actionFunc={handleSetAdvertListFilter}
      filter={filter}
      responsive={{
        city: { xs: 24, md: 12, lg: 8 },
        district: { xs: 24, md: 12, lg: 8 },
        neighbourhood: { xs: 24, md: 12, lg: 8 },
      }}
      multipleFields={{
        country: undefined,
        stateProvince: undefined,
        district: "multiple",
        city: "multiple",
      }}
      viewingFields={{
        country: false,
        stateProvince: true,
        district: true,
        city: true,
      }}
      fieldsRequiredRules={{
        country: false,
        stateProvince: false,
        district: false,
        city: false,
      }}
      form={props.form}
      allowClear={true}
    />
  );
};

export default Address;
